import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { Switch, Popper, Checkbox, Radio } from '@mui/material';
import {
  selectDraftConfig,
  saveRound,
  saveAllTeams,
  saveSingleTeam,
  saveTeams,
  setTimeSpeed,
  setResetRound,
  setResetInfoDraft,
  setResetTeamsDraftPlayerChoosePlayer,
  setDraftCardDepth,
  setDraftRandomness,
  setRoundDepth,
  checkRoundBPA,
  checkFanaticChallenge,
  setFanaticChallenge,
  fanaticModeAction,
  setFanaticModeValue,
  setDraftRandomnessTeam,
  setTeamSelectIndex,
  setTradingSimulator,
  setTradingSimulatorAction,
  applySettingDefaults,
} from '../../app/features/draftConfig/draftConfigSlice';
import { setRandomAccepted } from '../../app/features/trades/tradesSlice';
import { selectDraftCount } from '../../app/features/draftCount/draftCountSlice';
import { getFilterTwoData, getRandom, findTeamIndex } from '../../utils/utils';
import { getTeams, getSetting } from '../../app/features/draftConfig/drafConfigAction';
import { resDraftResult } from '../../app/features/draftResult/draftResultSlice';
import { setResetTrades } from '../../app/features/trades/tradesSlice';
import { resPlayersDraft } from '../../app/features/playersDraft/playersDraftSlice';
import { getDraftTotalCount } from '../../app/features/draftCount/draftCountActions';
import ModalShell from './ModalShell';
import { getTeamColor, getTeamAbbr } from '../../utils/constants';
import {
  PageWrap,
  Container,
  TwoColLayout,
  LeftCol,
  RightCol,
  ControlsRow,
  ControlBlock,
  ControlLabel,
  AdvancedSubtitle,
  AdvancedHeaderRight,
  DraftModeOptionsBtn,
  ButtonGroup,
  SelectBtn,
  RoundBtn,
  LoadDraftBtn,
  LoadDraftBtnWrapper,
  TeamsLoaderWrap,
  TeamsSpinner,
  TeamsGrid,
  TeamSquares,
  ShowCheck,
  TeamSquareBg,
  TeamSquare,
  TeamLogoRow,
  TeamName,
  TeamAbbr,
  TeamDivider,
  TeamPick,
  ConfigHeader,
  ConfigTitle,
  ConfigSubtitle,
  ConfigCard,
  AdvancedSection,
  AdvancedModalBody,
  ResetDefaultsRow,
  ResetDefaultsBtn,
  AdvancedSummaryCard,
  DraftModeRow,
  AdvancedSummaryIconWrap,
  AdvancedSummaryRowContent,
  AdvancedSummaryRowTitle,
  IntensityWrap,
  IntensityBadge,
  IntensityPopover,
  IntensityPopoverTitle,
  SettingRow,
  SettingLabel,
  SettingSliderWrap,
  SettingMarksRow,
  SettingCheckRow,
  SettingCheckLabel,
  SettingDivider,
  TeamsHeader,
  TeamsHeaderRight,
  DraftTotalCount,
} from './DraftPlayerV2.styles';

const BPAIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
  </svg>
);
const TrophyIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 5h-2V3H7v2H5C3.9 5 3 5.9 3 7v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"/>
  </svg>
);
const FlameIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"/>
  </svg>
);
const FlagIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"/>
  </svg>
);
const ClipboardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"/>
  </svg>
);

// The draft modes, one at a time. A plain mock draft is the "Single Mock Draft" row.
// The challenges: id → [fanaticChallenge mode, iterations].
const CHALLENGES = { frc: [1, 5], src: [2, 10], trc: [3, 10] };
const DRAFT_MODES = [
  { id: 'plain', title: 'Single Mock Draft', Icon: ClipboardIcon, color: '#6b7280' },
  { id: 'frc', title: '1st Round Challenge', Icon: FlagIcon, color: '#7c3aed' },
  { id: 'src', title: '2nd Round Challenge', Icon: FlagIcon, color: '#7c3aed' },
  { id: 'trc', title: '3rd Round Challenge', Icon: FlagIcon, color: '#7c3aed' },
  { id: 'fanatic', title: 'Fanatic Mode', Icon: FlameIcon, color: '#ea580c' },
];
const HistoryIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>
  </svg>
);
const QuestionIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{opacity: 0.45, flexShrink: 0}}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
  </svg>
);

const CHECK_ICON =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA2klEQVR4Ae2W4Q2CMBSEbwRGYARGcANHkBHcwG6gG+AGjOAIjMAIjvB8hhoJtFiwnCb0S/hDev0OUmiBRIKMiOT4FSqvpKPVKwOTnvzFESxUdpIxezDwyA0Y/KP8AgYqOjjkVzDwyGswUFHhkDfC+Oat/D6Qtyx5bmVDeY61iSK3k9xs+Dwz9/2Ta6AcTFIFZOK9dg3tZEw1MT5zyJ8LsMBSNGxCSlh54xi7XD6nhLzXSp8SsZgqIeM9Pa78Q4nWcc9gLTwlOPKAEgYsHCUM2Ej3o6qFeZBMbIYHWqKukKBn/8oAAAAASUVORK5CYII=';

const SPEED_OPTIONS = [
  { label: 'Slow',       value: 1 },
  { label: 'Normal',     value: 3 },
  { label: 'Fast',       value: 4 },
  { label: 'Lightspeed', value: 5 },
];

const ROUNDS = [1, 2, 3, 4, 5, 6, 7];

const DraftPlayerConfig = ({ onShowBoard }) => {
  const dispatch = useDispatch();
  const {
    teams, teamSelect, teamSelectId, round, timeSpeed, fanaticChallenge, loading: teamsLoading,
    draftCardDepth, draftRandomness, roundDepth, roundBPA,
    fanaticMode, fanaticModeValue,
  } = useSelector(selectDraftConfig);
  const { totalCount, loading: countLoading, error: countError } = useSelector(selectDraftCount);

  const [showAdvancedModal, setShowAdvancedModal] = useState(false);
  const [showIntensityPopover, setShowIntensityPopover] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (!showIntensityPopover) return;
    const handleClickOutside = (e) => {
      if (
        anchorEl && !anchorEl.contains(e.target) &&
        !e.target.closest('[data-intensity-popover]')
      ) {
        setShowIntensityPopover(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showIntensityPopover, anchorEl]);

  useEffect(() => {
    dispatch(setResetRound());
    dispatch(getTeams());
    dispatch(getSetting());
    dispatch(resDraftResult());
    dispatch(setResetTrades());
    dispatch(setResetTeamsDraftPlayerChoosePlayer());
    dispatch(setResetInfoDraft());
    dispatch(resPlayersDraft());
    dispatch(getDraftTotalCount());
  }, [dispatch]);

  useEffect(() => {
    if (teams.length && teamSelect.length !== 32) {
      const exceptTeam = getFilterTwoData(teams, teamSelectId, 'index');
      const exceptTeamId = exceptTeam.map(item => item.index);
      // At most as many as the simulated teams left. With nearly every team selected (Select All,
      // then untick one) there can be fewer than draftRandomness, and getRandom throws.
      const randomTeams = getRandom(exceptTeamId, Math.min(draftRandomness, exceptTeamId.length));
      dispatch(setRandomAccepted(teamSelect.length === 1));
      dispatch(setDraftRandomnessTeam(randomTeams));
      if (teamSelect.length === 1) {
        dispatch(setTeamSelectIndex(findTeamIndex(teams, teamSelect) + 1));
      }
    }
    if (teams.length && teamSelect.length > 1) {
      dispatch(setTradingSimulator(1));
      dispatch(setTradingSimulatorAction(false));
    }
  }, [teamSelectId, draftRandomness]);

  const activeSpeed =
    SPEED_OPTIONS.find((o) => o.value === timeSpeed)?.value ?? SPEED_OPTIONS[1].value;

  // The draft total count is posted by DraftBoard when the draft finishes, not here.
  const handleLoadDraft = () => {
    if (!teamSelect.length) return;
    onShowBoard();
  };

  // Multiple teams are for a plain mock draft only — the challenges and fanatic mode are built
  // around one user team (client, 2026-09-22), and their rules for uniqueness and pick
  // replacement are all written in the singular.
  const multiTeamAllowed = !fanaticChallenge.length && !fanaticMode;
  const allSelected = teams.length > 0 && teamSelectId.length === teams.length;

  const handleTeamClick = (team) => {
    dispatch(multiTeamAllowed ? saveTeams(team) : saveSingleTeam(team));
  };

  const handleSelectAll = (checked) => {
    dispatch(saveAllTeams(checked ? teams : []));
  };

  const draftMode = fanaticMode
    ? 'fanatic'
    : ({ 1: 'frc', 2: 'src', 3: 'trc' }[fanaticChallenge[0]?.mode] ?? 'plain');

  // Only called for a mode that isn't selected yet: a checked radio doesn't fire onChange, so
  // checkFanaticChallenge never gets the same mode twice (that would turn the challenge off).
  const selectDraftMode = (next) => {
    if (fanaticMode) {
      dispatch(fanaticModeAction(false)); // also clears any challenge
      setShowIntensityPopover(false);
    }
    if (next === 'fanatic') dispatch(fanaticModeAction(true));
    else if (next === 'plain') dispatch(setFanaticChallenge([]));
    else dispatch(checkFanaticChallenge(...CHALLENGES[next]));
  };

  return (
    <PageWrap>
      <Container>
        <TwoColLayout>
        
          {/* Right — draft settings */}
          <RightCol>
            <ConfigHeader>
              <div>
                <ConfigTitle>Draft Configuration</ConfigTitle>
                <ConfigSubtitle>Customize your mock draft settings below</ConfigSubtitle>
              </div>
            </ConfigHeader>

            <ConfigCard>
              <ControlsRow>
                <ControlBlock>
                  <ControlLabel>Speed</ControlLabel>
                  <ButtonGroup>
                    {SPEED_OPTIONS.map((opt) => (
                      <SelectBtn
                        key={opt.value}
                        className={activeSpeed === opt.value ? 'active' : ''}
                        onClick={() => dispatch(setTimeSpeed(opt.value))}
                      >
                        {opt.label}
                      </SelectBtn>
                    ))}
                  </ButtonGroup>
                </ControlBlock>

                {/* Mobile shows Rounds first, then Speed: the -2/-1 orders move Rounds and this
                    divider ahead of Speed. Desktop keeps the markup order. */}
                <SettingDivider $mobileOrder={-1} />

                <ControlBlock $mobileOrder={-2}>
                  <ControlLabel>Number of Rounds</ControlLabel>
                  <ButtonGroup>
                    {ROUNDS.map((r) => (
                      <RoundBtn
                        key={r}
                        className={r === +round ? 'active' : ''}
                        onClick={() => {
                          if (!fanaticChallenge.length) dispatch(saveRound(r));
                        }}
                      >
                        {r}
                      </RoundBtn>
                    ))}
                  </ButtonGroup>
                </ControlBlock>

                <SettingDivider />

                <ControlBlock>
                  <AdvancedSection>
                    <div>
                      <ControlLabel>Advanced Settings</ControlLabel>
                      <AdvancedSubtitle>How simulated teams pick</AdvancedSubtitle>
                    </div>
                    {/* One draft mode at a time. Each row is a label, so the whole row selects it; the
                        Options and Intensity buttons inside are interactive, so they don't. htmlFor
                        is needed: without it a label belongs to its first control, the button. */}
                    <AdvancedSummaryCard role="radiogroup" aria-label="Draft mode">
                      {DRAFT_MODES.map(({ id, title, Icon, color }) => (
                      <DraftModeRow as="label" htmlFor={`draft-mode-${id}`} key={id} className={draftMode === id ? 'active' : ''}>
                        <AdvancedSummaryIconWrap style={{ color }}>
                          <Icon />
                        </AdvancedSummaryIconWrap>
                        <AdvancedSummaryRowContent style={{ flex: 1 }}>
                          <AdvancedSummaryRowTitle>{title}</AdvancedSummaryRowTitle>
                        </AdvancedSummaryRowContent>
                        {/* The advanced settings only apply to a plain mock draft. */}
                        {id === 'plain' && draftMode === 'plain' && (
                          <DraftModeOptionsBtn type="button" onClick={() => setShowAdvancedModal(true)}>
                            <span>Options</span>
                            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 10l5 5 5-5z"/></svg>
                          </DraftModeOptionsBtn>
                        )}
                        {id === 'fanatic' && fanaticMode && (
                          <IntensityWrap>
                            <IntensityBadge
                              type="button"
                              ref={(el) => setAnchorEl(el)}
                              onClick={() => setShowIntensityPopover(p => !p)}
                            >
                              <span>Intensity: {fanaticModeValue}</span>
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                <path d="M7 10l5 5 5-5z"/>
                              </svg>
                            </IntensityBadge>
                            <Popper
                              open={showIntensityPopover}
                              anchorEl={anchorEl}
                              placement="top-end"
                              modifiers={[
                                { name: 'offset', options: { offset: [0, 10] } },
                              ]}
                              style={{ zIndex: 200 }}
                            >
                              <IntensityPopover data-intensity-popover>
                                <IntensityPopoverTitle>Fanatic Intensity</IntensityPopoverTitle>
                                <Box sx={{ width: '100%' }}>
                                  <Slider
                                    step={1} min={2} max={8}
                                    value={fanaticModeValue}
                                    onChange={(e) => dispatch(setFanaticModeValue(e.target.value))}
                                    valueLabelDisplay="auto"
                                  />
                                </Box>
                                <SettingMarksRow><span>Less (2)</span><span>More (8)</span></SettingMarksRow>
                              </IntensityPopover>
                            </Popper>
                          </IntensityWrap>
                        )}
                        <Radio
                          id={`draft-mode-${id}`}
                          name="draft-mode"
                          checked={draftMode === id}
                          onChange={() => selectDraftMode(id)}
                          inputProps={{ 'aria-label': title }}
                          sx={{ padding: '4px' }}
                        />
                      </DraftModeRow>
                      ))}
                    </AdvancedSummaryCard>
                  </AdvancedSection>
                </ControlBlock>
                
              </ControlsRow>
            </ConfigCard>

            <LoadDraftBtnWrapper>
              <LoadDraftBtn disabled={!teamSelect.length} onClick={handleLoadDraft}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
                Enter Draft
              </LoadDraftBtn>
            </LoadDraftBtnWrapper>
          </RightCol>

          {/* Left — team picker */}
          <LeftCol>
            <TeamsHeader>
              <div>
                <ConfigTitle>Choose your team</ConfigTitle>
                <ConfigSubtitle>Teams are listed by their first pick</ConfigSubtitle>
              </div>
              <TeamsHeaderRight>
                {!countLoading && !countError && totalCount != null && (
                  <DraftTotalCount>Draft total count: {totalCount}</DraftTotalCount>
                )}
                {/* Left visible but disabled outside a plain mock draft, so it's clear the option
                    exists and why it can't be used, rather than the control vanishing. */}
                <AdvancedHeaderRight
                  $disabled={!multiTeamAllowed}
                  title={multiTeamAllowed ? undefined : 'Multiple teams are not available in the challenges or fanatic mode'}
                >
                  Select All
                  <Switch
                    checked={allSelected}
                    disabled={!multiTeamAllowed}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    inputProps={{ 'aria-label': 'Select all teams' }}
                  />
                </AdvancedHeaderRight>
              </TeamsHeaderRight>
            </TeamsHeader>

            {(teamsLoading || !teams.length) && (
              <TeamsLoaderWrap>
                <TeamsSpinner />
              </TeamsLoaderWrap>
            )}

            <TeamsGrid>
              {teams.map((team) => {
                const isSelected = teamSelectId.includes(team.index);
                return (
                  <TeamSquares
                    key={team.id}
                    className={isSelected ? 'selected' : ''}
                    onClick={() => handleTeamClick(team)}
                  >
                    <ShowCheck className={isSelected ? 'visible' : ''}>
                      <img src={CHECK_ICON} alt="selected" />
                    </ShowCheck>
                    <TeamSquareBg className="team-square-bg" style={{ backgroundColor: getTeamColor(team.name) }}>
                      <img className="bg-image" src={team.logo} alt="" />
                    </TeamSquareBg>
                    <TeamSquare>
                      <TeamLogoRow>
                        <img src={team.logo} alt={team.name} />
                        <TeamName>{team.name}</TeamName>
                        <TeamAbbr>{getTeamAbbr(team.name)}</TeamAbbr>
                      </TeamLogoRow>
                      <TeamDivider />
                      <div>
                        <TeamPick>{team.selection}</TeamPick>
                      </div>
                    </TeamSquare>
                  </TeamSquares>
                );
              })}
            </TeamsGrid>
          </LeftCol>
        </TwoColLayout>
      </Container>

      {showAdvancedModal && (
        <ModalShell title="Advanced Settings" onClose={() => setShowAdvancedModal(false)} maxWidth={480}>
          <AdvancedModalBody>
            <div>
              <div style={{padding:"10px 0"}}>
                <SettingLabel style={{ marginBottom: 10 }}>Best Player Available</SettingLabel>
                <SettingCheckRow>
                  <SettingCheckLabel>
                    <Checkbox
                      checked={roundBPA.includes(1)}
                      disabled={!(+round >= 1)}
                      onChange={() => dispatch(checkRoundBPA(1))}
                      sx={{ padding: '2px' }}
                    />
                    1st round BPA
                  </SettingCheckLabel>
                  <SettingCheckLabel>
                    <Checkbox
                      checked={roundBPA.includes(2)}
                      disabled={!(+round >= 2)}
                      onChange={() => dispatch(checkRoundBPA(2))}
                      sx={{ padding: '2px' }}
                    />
                    2nd round BPA
                  </SettingCheckLabel>
                </SettingCheckRow>
              </div>
              <SettingDivider />
              <SettingRow>
                <SettingLabel>Draft card depth</SettingLabel>
                <SettingSliderWrap>
                  <Box sx={{ width: '100%' }}>
                    <Slider
                      step={1} min={2} max={8}
                      value={draftCardDepth}
                      onChange={(e) => dispatch(setDraftCardDepth(e.target.value))}
                      valueLabelDisplay="auto"
                    />
                  </Box>
                  <SettingMarksRow><span>Less (2)</span><span>More (8)</span></SettingMarksRow>
                </SettingSliderWrap>
              </SettingRow>
              <SettingDivider />
              <SettingRow>
                <SettingLabel>Draft randomness</SettingLabel>
                <SettingSliderWrap>
                  <Box sx={{ width: '100%' }}>
                    <Slider
                      step={1} min={2} max={16}
                      value={draftRandomness}
                      onChange={(e) => dispatch(setDraftRandomness(e.target.value))}
                      valueLabelDisplay="auto"
                    />
                  </Box>
                  <SettingMarksRow><span>Less (2)</span><span>More (16)</span></SettingMarksRow>
                </SettingSliderWrap>
              </SettingRow>
              <SettingDivider />
              <SettingRow>
                <SettingLabel>Round depth</SettingLabel>
                <SettingSliderWrap>
                  <Box sx={{ width: '100%' }}>
                    <Slider
                      step={1} min={2} max={5}
                      value={roundDepth}
                      onChange={(e) => dispatch(setRoundDepth(e.target.value))}
                      valueLabelDisplay="auto"
                    />
                  </Box>
                  <SettingMarksRow><span>Less (2)</span><span>More (5)</span></SettingMarksRow>
                </SettingSliderWrap>
              </SettingRow>
              <SettingDivider />
              {/* Back to the admin's defaults (user/settings/) for everything in this dialog. */}
              <ResetDefaultsRow>
                <ResetDefaultsBtn type="button" onClick={() => dispatch(applySettingDefaults())}>
                  <HistoryIcon />
                  Reset to Defaults
                </ResetDefaultsBtn>
              </ResetDefaultsRow>
            </div>
          </AdvancedModalBody>
        </ModalShell>
      )}
    </PageWrap>
  );
};

export default DraftPlayerConfig;
